<div #scannerElement 
[ngClass]="fullScannerHeight ? 'full-height' : 'half-height'">

</div>